import { render, staticRenderFns } from "./PlansList.vue?vue&type=template&id=534f34b4"
import script from "./PlansList.vue?vue&type=script&lang=js"
export * from "./PlansList.vue?vue&type=script&lang=js"
import style0 from "./PlansList.vue?vue&type=style&index=0&id=534f34b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports